import { Button, ButtonProps } from '@material-ui/core'

type SecondaryButtonProps = {
  outlined?: boolean
  buttonText?: string
  minWidth?: string
}

const defaultProps = {
  outlined: false,
  buttonText: '',
  minWidth: '128px',
}

export const SecondaryButton = ({
  disabled,
  outlined,
  buttonText,
  minWidth,
  ...props
}: SecondaryButtonProps & ButtonProps & typeof defaultProps) => {
  return (
    <Button
      disabled={disabled}
      disableElevation
      variant={outlined ? 'outlined' : 'contained'}
      className="px-6 h-14 text-lg font-medium normal-case"
      style={{
        minWidth: minWidth,
        border: outlined ? '2px solid' : '',
        borderColor: outlined ? '#FCBC00' : '',
        backgroundColor: outlined ? 'white' : '#FCBC00',
        color: outlined ? '#FCBC00' : 'black',
        opacity: disabled ? '0.5' : '1',
      }}
      {...props}
    >
      {buttonText}
    </Button>
  )
}

SecondaryButton.defaultProps = defaultProps
